import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';

type DeleteWatermarkModalProps = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  working: boolean;
  mode?: string;
};

const DeleteWatermarkModal = ({ open, onClose, onDelete, working, mode = 'channel' }: DeleteWatermarkModalProps) => {
  return (
    <Modal
      open={open}
      customSize={{
        width: '500px',
        height: '216px',
      }}
      contentWrapperClassName="padding-h-40 padding-v-24 gap-16"
      onRequestClose={onClose}
      RenderHeaderContent={() => (
        <Container className="radius-10">
          <Text color="var(--gray-100)" className="H4">
            {mode === 'project' ? 'Would you like to remove this watermark?' : 'Are you sure you want to delete?'}
          </Text>
        </Container>
      )}
      RenderFooterContent={() => (
        <Container borderRadius="0 0 12px 12px" className="flex fd-row jc-flex-end ai-center gap-16">
          <Button design="LocalBttnSecHalfTransp" designSize="large" onClick={onClose} disabled={working}>
            <Text className="L1">Cancel</Text>
          </Button>
          <Button
            backgroundColor={getThemeColorCSSVariable()}
            hoverBackgroundColor={getThemeColorsCssMixVariable()}
            designSize="large"
            loading={working}
            disabled={working}
            onClick={onDelete}
          >
            <Text className="L1" color={getThemeColorContrastCSSVariable()}>
              Delete
            </Text>
          </Button>
        </Container>
      )}
    >
      <Container className="overflow-auto" height="100%">
        <Text color="var(--global-ico-text-3)" className="P1">
          {mode === 'project'
            ? 'It will still be available in the watermark library. To delete it permanently close this modal and click edit.'
            : 'The watermark will be deleted from the channel library but it won’t affect the projects that are currently using it.'}
        </Text>
      </Container>
    </Modal>
  );
};

export default DeleteWatermarkModal;
